module.exports = __webpack_public_path__ + "img/product-1.18bd560e.svg";